module.exports = __webpack_public_path__ + "media/images/breadcrumb/shop-40c425779631a6570e9592ec726a44b1.svg";